module.exports = __webpack_public_path__ + "static/media/Lucky.2151ec61.jpeg";